import React from 'react'
import {ga} from 'shared'

export class NoResult extends React.Component {
  componentDidUpdate() {
    let currentCategory = $('.category-selection').text()
    let currentLocation = $('.location-selection').text()
    let eventDetails = `Category: ${currentCategory} / Location: ${currentLocation}`
    ga('send', 'event', 'discover projects: detail', 'zero results', eventDetails, { nonInteraction: true })
  }

  render() {
    return <div className="generic-no-results">
             {I18n.t('discover.categories.index.no_result_hint')}
           </div>
  }
}
